module.exports = __webpack_public_path__ + "static/media/contract.317ed4c6.svg";